import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import Swal from 'sweetalert2';
import { connect } from "socket.io-client";



@Injectable({
  providedIn: 'root'
})
export class ConnectBackendService {
  // private websocket: WebSocket;
  public url: string = environment.api_url;
  private socketIo: any;
  private socketUrl = environment.socketurl;
  private  clientSocketId: string ;

  private dataFromSocket = new BehaviorSubject<string | null>(null);

  public onDataFromSocket = this.dataFromSocket.asObservable();

  // public get getClientSocketId(): string {
  //   return this.clientSocketId;
  // }

  resetDataSocket(value): void {
    this.dataFromSocket.next(value);
  }

  constructor(private http: HttpClient, private router: Router, private route: ActivatedRoute) {
    this.clientSocketId = '';
    // this.socketIo = connect(this.socketUrl, {
    //   reconnectionDelay: 5000,
    //   reconnectionDelayMax: 8000,
    //   transports: [
    //     'websocket'
    //   ],
    //   autoConnect: true,

    // });

    // this.socketIo = io('http://localhost:5000/ws', {
    //   reconnectionDelay: 5000,
    //   reconnectionDelayMax: 8000,
    //   transports: [
    //     'websocket'
    //   ],
    //   upgrade: false,
    //   autoConnect: true,
    //   auth: {},
    // });

    // this.socketIo.open();

    // this.socketIo.on('connect', () => {
    //   this.clientSocketId = this.socketIo.id;

    // });

    // this.socketIo.on('barcode', (data) => {
    //   this.dataFromSocket.next(JSON.stringify(data));
    // });

    // this.socketIo.on('connect_app', (data) => {
    //   this.dataFromSocket.next(JSON.stringify(data));
    // });

    // this.socketIo.on('connect_error', (err) => {
    //   console.log('Socket Error', err);
    // });

    // this.socketIo.on('onNewMessage', (data) =>{
    //     console.log(data)
    // })

    // this.socketIo.on('disconnect', () => {
    //    // console.log(this.socketIo.id);
    //    setTimeout(() => {
    //       this.socketIo.open();
    //    }, 5000);
    // });

    // this.websocket = new WebSocket('ws://localhost:5000/ws', )
    // this.websocket.addEventListener("open", (ev => {
    //   console.log('opened')
    //   let data = { 
    //     "printerName" : "printer name aaaa",
    //     "jobId" : "1234"
    //   };
    //   let json = JSON.stringify(data);
    //   this.websocket.send(json)
    // }));
    
   
   
  }

  // public initUser(): void {
  //   this.socketIo.emit('initUser', this.clientSocketId)
  // }

  // public sendMessage(message): void {
  //   const data = {
  //     message,
  //     userSocketFromId: this.clientSocketId
  //   };
  //   this.socketIo.emit('message', data, (response) =>{
  //     console.log(response.status)
  //   });
  // }

  public sendMessageCustomer(message): void {
    const data = {

    }
  }


  getHeadersAut(): object {
    const headersAut = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('JposToken')!,
      }),
    };
    //console.log(localStorage.getItem('JposToken'))
    return headersAut;
  }

  getHeadersUpload(): object {
    const headersUp = {
      headers: new HttpHeaders({
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json'
      }),
    };
    return headersUp;
  }

  get isLoggedIn(): boolean {
    const authToken = localStorage.getItem('JposToken');
    return (authToken !== null) ? true : false;
  }



  get(path: string): Observable<any> {
    return this.http
      .get<any>(this.url + path, this.getHeadersAut())
      .pipe(catchError(this.handleError));
  }

  put(jsonreq: any, path: string): Observable<any> {
    return this.http
      .put<any>(this.url + path, jsonreq, this.getHeadersAut())
      .pipe(catchError(this.handleError));
  }

  post(jsonreq: any, path: string): Observable<any> {
    return this.http
      .post<any>(this.url + path, jsonreq, this.getHeadersAut())
      .pipe(catchError(this.handleError));
  }
  upload_file(jsonreq: any, path: string): Observable<any> {
    return this.http
      .post<any>(this.url + path, jsonreq)
      .pipe(catchError(this.handleError));
  }

  delete(path: string): Observable<any> {
    return this.http
      .delete<any>(this.url + path, this.getHeadersAut())
      .pipe(catchError(this.handleError));
  }



  // Error
  handleError(error: HttpErrorResponse) {
    let msg = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      msg = error.error.message;

    } else {
      // server-side error
      msg = `Error Code: ${error.status}\nMessage: ${error.message}`;


    }
    return throwError(msg);
  }
}

@Injectable()
export class AuthIntercept implements HttpInterceptor {

  constructor(private router: Router) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('JposToken');
    let newReq = req.clone({
      withCredentials: false,
      headers: req.headers.set('Authorization', ' ' + token)
    });

    return next.handle(newReq).pipe(
      catchError((err: HttpErrorResponse,) => {
        if (err.status === 401 || err.status === 403) {

          let message = 'Session หมดอายุการใช้งาน กรุณาเข้าอยู่ระบบใหม่อีกครั้ง';
          if (err.error.message === 'one more device') {
            message = 'มีการเข้าใช้งานในอุปกรณ์ซ้ำกัน กำลังออกจากระบบ'
          }

          Swal.fire('คำเตือน', message, 'error')
            .then(resp => {
              localStorage.removeItem('JposToken');
              this.router.navigate(['']);
              localStorage.clear();
            })
            .catch(err => {
              console.log(err);
            });
          return throwError(err.message);
        } else {
          return throwError(err);
        }
      })
    );
  }
}


